/* eslint-disable import/no-unresolved */
/* eslint-disable react/jsx-no-bind */
import * as React from "react";
import EditIcon from "@mui/icons-material/Edit";
import Button from "@mui/material/Button";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useFormik } from "formik";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { setStepDetails } from "src/redux/Actions/common";
// import { Dispatch, SetStateAction } from "react";
import ReviewHeading from "src/shared/ReviewHeading";
import {
  jointMedicalInitialValues,
  jointMedicalValidationSchema
} from "src/helpers/FormDetails/JointLifeAddendum";
import CustomButton from "../../../../shared/CustomButton";
import MedicalAndLifestyle from "../../../../shared/MedicalLifeStyle";
import JointLifeMember from "./JointLifeMember";
import SecondaryDetails from "./SecondaryDetails";
import MorePolicyDetails from "./MorePolicyDetails";
import JointCovidAndNriReview from "./JointCovidAndNri";
import {
  displayAdditionalQue,
  getQuestionnaireMapper
} from "../../../../helpers/FormDetails/ProposalDetails/MedicalAndLifeStyle/mapper";
import {
  calcAgeFromToday,
  showNewVersionUW
} from "../../../../helpers/FormDetails/ProposalDetails/resources";
import JointLifeMedicalV2 from "./JointLifeMedicalV2";

// import { useEffect } from "react";

function JointLife() {
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };
  const dispatch = useDispatch();
  const reviewStepNumber = useAppSelector((state): any => state.stepDetails.reviewStepNo);
  const jointLifeDetails = useAppSelector(
    (state) => state.jointLifeAddendum?.existingPolicy?.existingLifeCover
  );
  function onBack() {
    // setStepNo(stepNo - 1);
    dispatch(setStepDetails({ reviewStepNo: reviewStepNumber - 1 }));
    window.scrollTo(0, 0);
  }
  function onNext() {
    // setStepNo(stepNo + 1);
    dispatch(setStepDetails({ reviewStepNo: reviewStepNumber + 1 }));
    window.scrollTo(0, 0);
  }
  const MedicalAndLifeStyle = useAppSelector((state) => state.jointLifeAddendum);
  const gender = MedicalAndLifeStyle?.member?.gender;
  const productId = useAppSelector((state) => state.common.leadDetails?.productId);
  const partnerId = useAppSelector((state) => state.common?.leadDetails?.partnerId)!;

  const medicalQuestions = getQuestionnaireMapper(productId, partnerId);

  const sumAssured = useAppSelector((state) => state?.common?.leadDetails?.sumAssured);
  const jointLifeDob = useAppSelector((state) => state?.jointLifeAddendum?.member?.dob) || "";
  const toDisplayAdditionalQue = displayAdditionalQue(sumAssured, jointLifeDob);
  const nationality = useAppSelector((state) => state.jointLifeAddendum?.member?.nationalityCode);
  const jointMembersData = useAppSelector((state) => state?.common?.leadDetails?.Members)?.filter(
    (e: any) => e?.isJointMember
  )[0];

  const age = calcAgeFromToday(jointLifeDob);

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: jointMedicalInitialValues,
    validationSchema: jointMedicalValidationSchema(productId, age, partnerId),
    onSubmit: () => {
      // console.log("Submitting Joint Life Addendum form!!", formik);
    }
  });

  useEffect(() => {
    if (gender === "Male") {
      formik.setFieldValue("medicalDetails.gyneComplications", false);
      formik.setFieldValue("medicalDetails.pregnant", false);
      formik.setFieldValue("medicalDetails.pregnancyDuration", "");
    }
  }, []);

  return (
    <div className="min-h-screen bg-whiteSmoke">
      <div className="sm:pl-10.25 pl-4 bg-white sm:pr-10 pr-4 rounded-b-1.5xl">
        <div>
          <ReviewHeading label="Joint Details" />
          <div className="!justify-between mt-6 border border-solid rounded-xl border-bianchiGreen">
            <Accordion
              className="!rounded-xl !shadow-none !justify-between"
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                expandIcon={
                  <div>
                    {expanded !== "panel1" && (
                      <ExpandMoreIcon
                        className={`rounded-full border-2 border-coldMorning !p-1 ${
                          expanded === "panel1" ? "expanded" : ""
                        }`}
                      />
                    )}
                  </div>
                }
                aria-controls="panel1bh-content"
                id="panel2bh-header"
              >
                <Typography className="!text-base !font-bold !font-montserrat flex !justify-between">
                  <div className="grid grid-flow-row-dense !justify-between  ">
                    <div className="col-span-1">General Details</div>
                  </div>
                </Typography>

                {expanded === "panel1" && (
                  <div className="rounded-full !bg-lightGrayishRed lg:ml-75/100 md:ml-65/100 ml-27/100 ">
                    <EditIcon className="!text-sm !pl-1 !text-hotShot" />
                    <Button
                      onClick={() => {
                        dispatch(
                          setStepDetails({
                            parentStepNo: 3,
                            jointStepNo: 1
                          })
                        );
                      }}
                      className="!pb-1 !text-xxs !font-bold"
                    >
                      Edit Details
                    </Button>
                  </div>
                )}
              </AccordionSummary>
              <hr className="border-solid border-black opacity-30" />
              <AccordionDetails>
                <Typography>
                  <JointLifeMember />
                  <SecondaryDetails />
                  {jointLifeDetails && <MorePolicyDetails />}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          <div className="!justify-between mt-6 border border-solid rounded-xl border-bianchiGreen">
            <Accordion
              className="!rounded-xl !shadow-none"
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                expandIcon={
                  <div>
                    {expanded !== "panel2" && (
                      <ExpandMoreIcon
                        className={`rounded-full border-2 border-coldMorning !p-1 ${
                          expanded === "panel1" ? "expanded" : ""
                        }`}
                      />
                    )}
                  </div>
                }
                aria-controls="panel2bh-content"
                id="panel2bh-header"
              >
                <Typography className="!text-base !font-bold !font-montserrat">
                  Medical & Lifestyle
                </Typography>
                {expanded === "panel2" && (
                  <div className="rounded-full !bg-lightGrayishRed lg:ml-72/100 md:ml-61/100 ml-18/100 ">
                    <EditIcon className="!text-sm !pl-1 !text-hotShot" />
                    <Button
                      onClick={() => {
                        dispatch(
                          setStepDetails({
                            parentStepNo: 3,
                            jointStepNo: 2
                          })
                        );
                      }}
                      className="!pb-1 !text-xxs !font-bold"
                    >
                      Edit Details
                    </Button>
                  </div>
                )}
              </AccordionSummary>
              <hr className="border-solid border-black opacity-30" />
              <AccordionDetails>
                <Typography>
                  {showNewVersionUW(jointMembersData) ? (
                    <JointLifeMedicalV2 />
                  ) : (
                    <MedicalAndLifestyle
                      questions={medicalQuestions}
                      displayAdditionalQue={toDisplayAdditionalQue}
                      label="Joint Life"
                      isReview
                      jointMarginRequired
                      gender={gender}
                      formValues={MedicalAndLifeStyle}
                      setFieldValue={formik.setFieldValue}
                      handleBlurs={formik.handleBlur}
                      handleChanges={formik.handleChange}
                      setFieldTouch={formik.setFieldTouched}
                    />
                  )}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </div>
          {nationality !== "RES" && (
            <div className="!justify-between mt-6 border border-solid rounded-xl border-bianchiGreen">
              <Accordion
                className="!rounded-xl !shadow-none"
                expanded={expanded === "panel3"}
                onChange={handleChange("panel3")}
              >
                <AccordionSummary
                  expandIcon={
                    <div>
                      {expanded !== "panel3" && (
                        <ExpandMoreIcon
                          className={`rounded-full border-2 border-coldMorning !p-1 ${
                            expanded === "panel1" ? "expanded" : ""
                          }`}
                        />
                      )}
                    </div>
                  }
                  aria-controls="panel3bh-content"
                  id="panel5bh-header"
                >
                  <Typography className="!text-base !font-bold !font-montserrat">
                    NRI Details
                  </Typography>
                  {expanded === "panel3" && (
                    <div className="rounded-full !bg-lightGrayishRed lg:ml-78/100 md:ml-70/100 ml-37/100 ">
                      <EditIcon className="!text-sm !pl-1 !text-hotShot" />
                      <Button
                        onClick={() => {
                          dispatch(
                            setStepDetails({
                              parentStepNo: 3,
                              jointStepNo: 3
                            })
                          );
                        }}
                        className="!pb-1 !text-xxs !font-bold"
                      >
                        Edit Details
                      </Button>
                    </div>
                  )}
                </AccordionSummary>
                <hr className="border-solid border-black opacity-30" />
                <AccordionDetails>
                  <Typography>
                    <JointCovidAndNriReview />
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </div>
          )}
          <div className="sm:pl-10.25 pt-1 pl-4 bg-white sm:pr-10 pr-4 rounded-1.5xl mt-10 pb-10">
            <div className="w-full" />
            <CustomButton onBack={onBack} onNext={onNext} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default JointLife;
